import { PageMajorHeading } from '@components/buzzkuri/shared/uiParts/heading/PageMajorHeading'
import { Program, Slugs } from '@type/buzzkuri/programs-categor'
import React from 'react'
import { PopularProgramCardGroup } from './CardGroup'

type Props = {
  popularPrograms: Program[]
  slugs: Slugs
}

export const PopularProgram = ({
  popularPrograms,
  slugs,
}: Props): JSX.Element => (
  <>
    <div>
      <PageMajorHeading
        mainHeading={`${slugs[0]}の\n人気プログラム(対面/オンライン)TOP3`}
        MainHeadingTag="h1"
      />
    </div>
    <div className="mt-[10.4vw] lg:mt-[3.8vw]">
      <PopularProgramCardGroup {...{ popularPrograms, slug: slugs[0] }} />
    </div>
  </>
)
